import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FeaturedContent from './components/FeaturedContent';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '最新发布页',
    url: 'https://gdbtui7.cn',
    description: '汇聚平台全部最新内容，实时更新、分类清晰，让您第一时间获取最新资讯、产品、公告与活动信息。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://gdbtui7.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestArticles />
        <FeaturedContent />
      </main>
    </>
  );
}